
      import API from "!../../../sfd-v2/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../sfd-v2/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../sfd-v2/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../sfd-v2/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../sfd-v2/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../sfd-v2/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../sfd-v2/node_modules/css-loader/dist/cjs.js!./dockStyles.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../sfd-v2/node_modules/css-loader/dist/cjs.js!./dockStyles.css";
       export default content && content.locals ? content.locals : undefined;
